import React from "react";
import { useSelector } from "react-redux";
import ED from "../../img/logo-ed.png";
import { version } from "../../index";

export default function Footer() {
  const user = useSelector(state => state.auth.user);

  // Get version from environment variables

  return (
    <div className="footer footer-copyright d-flex justify-content-between text-muted py-3">
      {user.center &&
        <small className="px-2">
          Logged in as {user.username} for {user.center.name}
        </small>
      }
      <small className="ms-auto px-2">
        Powered by
        <img src={ED} alt="Logo Experience Data" className="ms-2 d-none" /> <a className="text-dark" href="https://www.experiencedata.nl/">Experience Data</a>
      </small>
      {user.is_lely_superuser &&
        <small className="px-2">
          Version <a className="text-dark" href={`https://github.com/experiencedata/phototool/releases/tag/${version}`} target="_blank" rel="noopener noreferrer">{version}</a>
        </small>
      }
      {!user.is_lely_superuser &&
        <small className="px-2">
          Version {version}
        </small>
      }
    </div>
  )
}
